import React, {Fragment} from 'react'
import { Button } from '@drifthq/tide-core'

import InstallNotification from "components/OnboardingInstallNotification"
import NotificationModal from 'components/NotificationModalExp'
import config from "config"

import './style.css'

const ERROR_MESSAGE = "We had trouble connecting to your Segment account - please try again."
const SEGMENT_REDIRECT_URI = `${config.CUSTOMER_WEB_URL}/accept-integration/segment`
const SEGMENT_ENABLE_BUTTON_SRC = "https://static.segment.com/enable-button/v1/index.js"

const creatingSegmentScript = () => {
  const segmentScript = document.createElement("script")
  segmentScript.src = SEGMENT_ENABLE_BUTTON_SRC
  document.head.appendChild(segmentScript)
}
const InstallSegment = ({
  embedId,
  apiKey,
  updating,
  showNextButton,
  handlePopUp,
  errorNotification,
  successNotification,
  onContinueClick,
}) => {
  creatingSegmentScript()
  const accessToken = apiKey.accessToken
  const dataSettings = JSON.stringify({apiKey: accessToken, embedId })
  const node = [<div key="unique-key-2" className="segment-enable-button" data-integration="drift" data-settings={dataSettings} data-redirect-url={SEGMENT_REDIRECT_URI} />]
  return (
    <Fragment>
      <p className="install-exp-segment-description">
        If you&#8217;re a Segment customer, you know how easy it is to get new integrations up and running. Just click the button below to connect your account and install Drift live on your site.
      </p>
      <InstallNotification
        errorText={ERROR_MESSAGE}
        isError={errorNotification && !successNotification}
      />
      { !showNextButton &&
        node.concat(<Button
          key="unique-key"
          onClick={handlePopUp}
          className="touchless-segment-verify-button"
          loading={updating}
        >
          Install Drift with Segment
        </Button>)
      }
      {showNextButton && 
        <Button
          onClick={onContinueClick}
          className="touchless-segment-verify-button"
        >
          Continue to Dashboard
        </Button>
      }
      {errorNotification && <div className="touchless-segment-verify-next" onClick={onContinueClick}>Continue to Dashboard</div>}
      <NotificationModal showModal={successNotification} text="You installed Drift successfully 🎉" />
    </Fragment>
  )
}

export default InstallSegment


// WEBPACK FOOTER //
// ./src/layouts/InstallSegment/component.js